import { Pipe, PipeTransform } from '@angular/core';
import { NotebookVizResult } from '@mode/notebooks/domain';

/**
 * If the ContentType of the cell is text/plain and the result type
 * is not an image, error or stderr
 */
@Pipe({
  name: 'notebookCellIsPlainText',
  pure: true,
})
export class NotebookCellIsPlainTextPipe implements PipeTransform {
  transform(cell: NotebookVizResult): boolean {
    return !['image', 'error', 'stderr'].some((t) => t === cell.result_type) && cell.content_type === 'text/plain';
  }
}
